import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PATH_DASHBOARD } from "../../routes/paths";
import axiosInstance from "../../utils/axios";

const initialState = {
  fetchLoading: false,
  isLoading: false,
  galleries: {
    data: [],
    meta: {
      total: 0,
    },
  },
  singleGallery: null,
};

export const createGallery = createAsyncThunk(
  "createGallery/gallery",
  async ({ data, enqueueSnackbar, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.post("medias", data);
      enqueueSnackbar("Gallery is added successfully");
      navigate(PATH_DASHBOARD.entries.galleries.list);
      return response.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchGalleries = createAsyncThunk(
  "fetchGalleries/gallery",
  async ({ enqueueSnackbar, limit = 1000, page = 0, status }, thunkApi) => {
    try {
      const response = await axiosInstance.get("medias", {
        params: {
          limit,
          page: page + 1,
          ...((status === true || status === false) && { active: status }),
        },
      });
      return {
        data: response.data.data.data,
        meta: {
          total: response.data.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchSingleGallery = createAsyncThunk(
  "fetchSingleGallery/gallery",
  async ({ enqueueSnackbar, slug }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`medias/${slug}`);

      return response.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const updateGallery = createAsyncThunk(
  "updateGallery/gallery",
  async ({ slug, data, enqueueSnackbar, setOpenEdit }, thunkApi) => {
    try {
      const response = await axiosInstance.post(
        `medias/${slug}?_method=PUT`,
        data
      );
      return {
        data: response.data.data,
        enqueueSnackbar,
        setOpenEdit,
        slug,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const deleteGallery = createAsyncThunk(
  "deleteGallery/gallery",
  async ({ id, enqueueSnackbar }, thunkApi) => {
    try {
      await axiosInstance.delete(`medias/${id}`);
      return { id, enqueueSnackbar };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const gallerySlice = createSlice({
  name: "gallery",
  initialState,
  extraReducers: (builder) => {
    // TODO: create gallery
    builder.addCase(createGallery.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createGallery.fulfilled, (state, action) => {
      state.isLoading = false;
      state.galleries.data = [action.payload, ...state.galleries.data];
      state.galleries.meta.total = state.galleries.meta.total + 1;
    });

    builder.addCase(createGallery.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: fetch gallery
    builder.addCase(fetchGalleries.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchGalleries.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.galleries = action.payload;
    });

    builder.addCase(fetchGalleries.rejected, (state, action) => {
      state.fetchLoading = false;
      // action.payload.enqueueSnackbar(action.payload.error.message, {
      //   variant: "error",
      // });
    });

    // ==========================

    // TODO: fetch single gallery
    builder.addCase(fetchSingleGallery.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchSingleGallery.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.singleGallery = action.payload;
    });

    builder.addCase(fetchSingleGallery.rejected, (state, action) => {
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: update gallery
    builder.addCase(updateGallery.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateGallery.fulfilled, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar("Gallery is updated successfully");
      // state.galleries.data = state.galleries.data.map((gallery) =>
      //   gallery.slug === action.payload.slug ? action.payload.data : gallery
      // );
      // console.log(action.payload);
      // action.payload.setOpenEdit(false);
    });

    builder.addCase(updateGallery.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: delete gallery
    builder.addCase(deleteGallery.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteGallery.fulfilled, (state, action) => {
      state.isLoading = false;
      state.galleries.data = state.galleries.data.filter(
        (gallery) => gallery.id !== action.payload.id
      );
      action.payload.enqueueSnackbar("Gallery is deleted successfully");
    });

    builder.addCase(deleteGallery.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================
  },
});

export default gallerySlice.reducer;
